import React from 'react';
import { Provider } from 'jotai';
import ReactDOM from 'react-dom/client';
import { ThemeProvider } from '@mui/material/styles';

import './index.css';
import ScreenRouter from './screenRouter';
import reportWebVitals from './reportWebVitals';
import theme from './theme';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <Provider>
        <ScreenRouter />
      </Provider>
    </ThemeProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
